import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import PopupPartageActif from "./ModalShareActif";
import { TieredMenu } from "primereact/tieredmenu";
import { Button } from "primereact/button";
import { AWS_BUCKET_ENV,AWS_BUCKET_NAME } from "../../config/awsParams";
import {
  ModalDeleteActif,
  ModalEditActif,
  ModalRenameActif,
  SlidOverDetailActif,
  ModalAccessActif,
} from "..";
import {
  countFilesRecursively,
  calculateTotalSizeRecursively,
} from "../../utils/FilesOperation";
import { useAuth } from "../../utils/UserProvider";
import { Actif } from "../../interfaces";
const ActifFolder = ({
  actif,
  deleteActif,
  verifieActif,
  archiveActif,
  EnAttenteActif,
  desarchiveActif,
}) => {
  const [visibleRight, setVisibleRight] = useState(false);
  const [selectedActif, setSelectedActif] = useState<Actif | null>(null);
  const menu = useRef(null);
  const { user } = useAuth();

  const isGexpertise = () =>
    user &&
    (user.role.includes("ADMIN_GEXPERTISE") ||
      user.role.includes("ASSISTANT_PROJET"));

  const isAdminOrMaitreAdmin = () =>
    user &&
    (user.role.includes("MAITRE_ADMIN_CLIENT") ||
      user.role.includes("ADMIN_CLIENT"));

  const isEditeurOrViewer = () =>
    user &&
    (user.role.includes("EDITEUR_CLIENT") ||
      user.role.includes("VIEWER_CLIENT"));

  const [modals, setModals] = useState({
    partage: false,
    acces: false,
    edit: false,
    delete: false,
    renommer: false,
  });

  const openModal = (modalName) => {
    setModals({ ...modals, [modalName]: true });
  };

  const closeModal = (modalName) => {
    setModals({ ...modals, [modalName]: false });
  };

  function customTemplate() {
    const isVerified = actif && actif.verified;
    return (
      <>
        {!isVerified ? (
          <button
            type="button"
            onClick={() => {
              verifieActif(actif?.id, actif);
            }}
            className="focus:outline-none text-white bg-green-600 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-full text-sm px-16 py-1 ml-4 my-2 "
          >
            Validé
          </button>
        ) : (
          <div className="mx-2 my-2">
            <button
              type="button"
              onClick={() => {
                EnAttenteActif(actif?.id, actif);
              }}
              className="focus:outline-none text-white bg-yellow-400 hover:bg-yellow-500 focus:ring-4 focus:ring-yellow-400 font-medium rounded-full text-sm px-12 py-1 ml-2 mb-2 "
            >
              En attente
            </button>
          </div>
        )}
      </>
    );
  }
  const items = [
    ...(isAdminOrMaitreAdmin() || isGexpertise()
      ? [
          {
            label: "Partager",
            icon: "pi pi-link",
            command: () => openModal("partage"),
            className: "pointer-events-none blur-[2px]",
          },
          ...(actif.interlocuteur_referent_id === user?.id
            ? [
                {
                  label: "Gérer l'accès",
                  icon: "pi pi-share-alt",
                  className: "pointer-events-none blur-[2px]",
                  command: () => openModal("acces"),
                },
              ]
            : []),
          ...(actif.interlocuteur_referent_id === user?.id
            ? [
                {
                  template: customTemplate,
                },
              ]
            : []),
        ]
      : []),

    {
      separator: true,
    },
    ...(isAdminOrMaitreAdmin() || isGexpertise()
      ? [
          {
            label: "Renommer",
            icon: "pi pi-pencil",
            command: () => {
              openModal("renommer");
              setSelectedActif(actif);
            },
          },
          {
            label: "Supprimer",
            icon: "pi pi-trash",
            command: () => {
              openModal("delete");
              setSelectedActif(actif);
            },
          },
          ...(!actif.in_archive
            ? [
                {
                  label: "Archiver",
                  icon: "pi pi-fw pi-calendar-times",
                  command: () => {
                    archiveActif(actif?.id, actif);
                  },
                },
              ]
            : [
                {
                  label: "Désarchiver",
                  icon: "pi pi-directions",
                  command: () => {
                    desarchiveActif(actif?.id, actif);
                  },
                },
              ]),
          {
            separator: true,
          },
        ]
      : []),
    ...(!actif.in_archive && (isAdminOrMaitreAdmin() || isGexpertise())
      ? [
          {
            label: "Editer",
            icon: "pi pi-file-edit",
            command: () => {
              openModal("edit");
              setSelectedActif(actif);
            },
          },
        ]
      : []),
    {
      label: "Détails",
      icon: "pi pi-info-circle",
      command: () => setVisibleRight(true),
    },
  ];

  return (
    <>
      <div
        className={`flex items-start rounded-sm w-80 h-36 bg-[#f4f4f5]  shadow-lg ${
          actif.in_archive ? "cursor-not-allowed opacity-60 hachures" : ""
        }`}
      >
        <div className="flex-grow">
          {actif.in_archive ? (
            <>
              <div className=" flex items-center justify-between p-4 pb-0.5">
                <div className="flex  items-center space-x-2">
                  <div className="flex items-center space-x-2">
                    <img
                      src={
                        actif.photo_actif
                          ? `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/actif_photos/${actif?.photo_actif}`
                          : "/images/folder 1.png"
                      }
                      className="w-14 h-14"
                    />
                    <span className=" text-sm  font-semibold ">
                      {actif?.nom_actif}
                    </span>
                  </div>
                  {actif?.verified ? (
                    <img src="/images/verifie1.png" className="w-5 h-5" />
                  ) : actif?.in_archive ? (
                    <img src="/images/archiver.png" className="w-5 h-5" />
                  ) : (
                    <img src="/images/sablier.png" className="w-6 h-6" />
                  )}
                </div>
                <div>
                  <Button
                    onClick={(e) => menu.current.toggle(e)}
                    icon="pi pi-ellipsis-v"
                    rounded
                    text
                    severity="secondary"
                    aria-label="Bookmark"
                    className="mb-10"
                  />

                  <TieredMenu
                    model={items}
                    popup
                    ref={menu}
                    breakpoint="767px"
                  />
                </div>
              </div>
              <div className="ml-52 flex items-center">
                {actif.members.slice(0, 3).map((member, index) => (
                  <img
                    key={index}
                    className="logo object-cover w-6 h-6 -mx-1 border-2 border-white rounded-full shrink-0"
                    src={
                      member.photo_user
                        ? member.photo_user
                        : "/images/profile.png"
                    }
                    alt={`Member ${index + 1}`}
                  />
                ))}
                {actif.members.length > 3 && (
                  <p className="w-6 h-6 -mx-1 text-xs text-blue-600 bg-blue-100 border-2 border-white rounded-full flex items-center justify-center">
                    +{actif.members.length - 3}
                  </p>
                )}
              </div>
              <div
                className={`flex ${
                  actif.members.length !== 0 ? "mt-5" : "mt-10"
                }  space-x-36`}
              >
                <p className=" ml-4  text-sm font-medium text-black">
                  {countFilesRecursively(actif)} fichier(s)
                </p>
                <span className="text-gray-400 font-medium text-sm">
                  {calculateTotalSizeRecursively(actif)}
                </span>
              </div>
            </>
          ) : (
            <>
              <div className=" flex items-center justify-between p-4 pb-0.5">
                <>
                  <div className="flex items-center space-x-2">
                    <Link to={`/actif/${actif.uuid}`}>
                      <div className="flex items-center space-x-2">
                        <div className="flex items-center space-x-2">
                          <img
                            src={
                              actif.photo_actif
                                ? `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/actif_photos/${actif?.photo_actif}`
                                : "/images/folder 1.png"
                            }
                            className="w-14 h-14"
                          />
                          <span className=" text-sm  font-semibold ">
                            {actif?.nom_actif}
                          </span>
                        </div>
                        {actif?.verified && !actif?.in_archive ? (
                          <img src="/images/verifie1.png" className="w-5 h-5" />
                        ) : (
                          <img src="/images/sablier.png" className="w-6 h-6" />
                        )}
                      </div>
                    </Link>
                  </div>
                  <div>
                    <Button
                      onClick={(e) => menu.current.toggle(e)}
                      icon="pi pi-ellipsis-v"
                      rounded
                      text
                      severity="secondary"
                      aria-label="Bookmark"
                      className="mb-10"
                    />

                    <TieredMenu
                      model={items}
                      popup
                      ref={menu}
                      breakpoint="767px"
                    />
                  </div>
                </>
              </div>
              <div className="ml-52 flex items-center">
                {actif.members.slice(0, 4).map((member, index) => (
                  <img
                    className="logo object-cover w-6 h-6 -mx-1 border-2 border-white rounded-full shrink-0"
                    src={
                      member.photo_user
                        ? member.photo_user
                        : "/images/profile.png"
                    }
                    alt={`Member ${index + 1}`}
                  />
                ))}
                {actif.members.length > 4 && (
                  <p className="w-6 h-6 -mx-1 text-xs text-blue-600 bg-blue-100 border-2 border-white rounded-full flex items-center justify-center">
                    +{actif.members.length - 4}
                  </p>
                )}
              </div>

              <div
                className={`flex ${
                  actif.members.length !== 0 ? "mt-5" : "mt-10"
                }  space-x-36`}
              >
                <p className=" ml-4  text-sm font-medium text-black">
                  {countFilesRecursively(actif)} fichier(s)
                </p>
                <span className="text-gray-400 font-medium text-sm">
                  {calculateTotalSizeRecursively(actif)}
                </span>
              </div>
            </>
          )}
        </div>
      </div>
      {visibleRight && (
        <SlidOverDetailActif
          actif={actif}
          setVisibleRight={setVisibleRight}
          visibleRight={visibleRight}
        />
      )}
      {modals.partage && (
        <PopupPartageActif
          actif={actif}
          modalIsOpenPartage={modals.partage}
          closeModalPartage={() => closeModal("partage")}
        />
      )}
      {modals.acces && (
        <ModalAccessActif
          actif={actif}
          modalIsOpenAcces={modals.acces}
          closeModalAcces={() => closeModal("acces")}
        />
      )}
      {modals.edit && (
        <ModalEditActif
          actif={selectedActif}
          modalIsOpenEditActif={modals.edit}
          closeModalEditActif={() => closeModal("edit")}
          setSelectedActif={setSelectedActif}
        />
      )}
      {modals.delete && (
        <ModalDeleteActif
          modalIsOpenDelete={modals.delete}
          closeModalDelete={() => closeModal("delete")}
          selectedActif={selectedActif}
          deleteActif={deleteActif}
        />
      )}
      {modals.renommer && (
        <ModalRenameActif
          modalIsOpenRenommer={modals.renommer}
          closeModalRenommer={() => closeModal("renommer")}
          selectedActif={selectedActif}
        />
      )}
    </>
  );
};

export default ActifFolder;
